import React from 'react';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition" data-id="element-153">
      <div className="mb-4" data-id="element-154">{icon}</div>
      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-155">{title}</h3>
      <p className="text-gray-600" data-id="element-156">{description}</p>
    </div>;
};
export default FeatureCard;